var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-3"},[_c('Period-Selector'),_c('Company-Selector')],1),_c('br'),_c('Leads-Card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }